import api, { VERSION } from '../configuracion/config';
import Header from '../../Plantilla/Header';
import { NavLink } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

function Inicio() {
  const year = new Date().getFullYear();

  // 🧠 estados
  const [minutasHoy, setMinutasHoy] = useState(0);
  const [sedes, setSedes] = useState(0);
  const [usuarios, setUsuarios] = useState(0);

  // 🪄 cargar datos
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const [resMinutas, resSedes, resUsuarios] = await Promise.all([
          api.get('/minutas/hoy'),
          api.get('/sedes/activas'),
          api.get('/usuarios/activos'),
        ]);

        setMinutasHoy(resMinutas.data.total);
        setSedes(resSedes.data.total);
        setUsuarios(resUsuarios.data.total);
      } catch (error) {
        console.error('Error cargando dashboard:', error);
      }
    };

    cargarDatos();
  }, []);

  return (
    <div>
      <style>
        {`
          body {
            background: linear-gradient(90deg, rgb(138, 6, 6), rgb(2, 94, 110));
            color: #ffffff;
          }

          .hero-container {
            position: relative;
            padding: 80px 20px;
          }

          .hero-card {
            backdrop-filter: blur(12px);
            border-radius: 16px;
            padding: 50px;
          }

          .title-main {
            font-size: 2.5rem;
            font-weight: 700;
            letter-spacing: 0.5px;
          }

          .subtitle {
            color: #ffffff;
            font-size: 1rem;
          }

          .divider {
            width: 60px;
            height: 3px;
            background: #498366;
            margin: 15px auto;
            border-radius: 2px;
          }

          .footer-link {
            transition: color 0.2s ease;
          }

          .footer-link:hover {
            color: #85774f !important;
          }

          /* 🌑 TARJETAS DARK MODE */
          .stat-card {
            background: linear-gradient(135deg, #1e1e2f, #2b2b3c);
            border-radius: 16px;
            padding: 25px;
            text-align: center;
            box-shadow: 0 10px 30px rgba(0,0,0,0.4);
            transition: all 0.35s ease;
            position: relative;
            overflow: hidden;
            color: #ffffff;
          }

          .stat-card::before {
            content: "";
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 60%);
            transform: rotate(25deg);
            opacity: 0;
            transition: 0.4s;
          }

          .stat-card:hover::before {
            opacity: 1;
          }

          .stat-card:hover {
            transform: translateY(-8px) scale(1.03);
            box-shadow: 0 25px 60px rgba(0,0,0,0.7);
          }

          /* 🎯 ICONOS */
          .stat-icon {
            font-size: 32px;
            margin-bottom: 10px;
            display: inline-block;
            padding: 12px;
            border-radius: 50%;
            background: linear-gradient(135deg, #11aa5d, #58a07c);
            color: white;
            box-shadow: 0 0 15px rgba(17,170,93,0.6);
          }

          /* 🔢 NUMEROS */
          .stat-card h3 {
            font-size: 30px;
            font-weight: bold;
            margin: 5px 0;
          }

        `}
      </style>

      <Header />

      {/* HERO */}
      <div className="hero-container text-center d-flex justify-content-center">
        <div className="container d-flex justify-content-center">
          <div className="hero-card col-md-8 col-lg-6">
            <h1 className="title-main">Sistema de Minutas</h1>
            <div className="divider"></div>

            {/* CARRUSEL */}
            <div id="carouselExample" className="carousel slide mt-4" data-bs-ride="carousel">
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <p className="subtitle">
                    Gestiona todas tus minutas de forma rápida, organizada y centralizada.
                  </p>
                </div>

                <div className="carousel-item">
                  <p className="subtitle">
                    Controla sedes, usuarios y operaciones en tiempo real desde un solo lugar.
                  </p>
                </div>

                <div className="carousel-item">
                  <p className="subtitle">
                    Optimiza procesos y mejora la trazabilidad de la información operativa.
                  </p>
                </div>
              </div>

              <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                <span className="carousel-control-prev-icon"></span>
              </button>

              <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                <span className="carousel-control-next-icon"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* MINI DASHBOARD */}
      <div className="container mt-4">
        <div className="row text-center">

          <div className="col-md-4 mb-3">
            <div className="stat-card">
              <div className="stat-icon">📄</div>
              <h3>{minutasHoy}</h3>
              <small style={{ color: "#cbd5e1" }}>Minutas de hoy</small>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="stat-card">
              <div className="stat-icon">🏢</div>
              <h3>{sedes}</h3>
              <small style={{ color: "#cbd5e1" }}>Sedes activas</small>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="stat-card">
              <div className="stat-icon">👤</div>
              <h3>{usuarios}</h3>
              <small style={{ color: "#cbd5e1" }}>Usuarios activos</small>
            </div>
          </div>

        </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-dark text-light pt-4 mt-auto border-top">
        <div className="container">
          <div className="row">

            <div className="col-md-4 mb-3">
              <h5 className="fw-bold">Transportes Medellín Castilla</h5>
              <p className="small text-secondary">
                Soluciones de transporte confiables, seguras y eficientes.
              </p>
            </div>

            <div className="col-md-4 mb-3">
              <h6 className="fw-bold">Navegación</h6>
              <ul className="list-unstyled small">
                <li>
                  <NavLink to="/inicio" className="text-light text-decoration-none footer-link">
                    Inicio
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/minutas" className="text-light text-decoration-none footer-link">
                    Minutas
                  </NavLink>
                </li>
              </ul>
            </div>

            <div className="col-md-4 mb-3">
              <h6 className="fw-bold">Contacto</h6>
              <ul className="list-unstyled small text-secondary">
                <li>📍 Medellín, Colombia</li>
              </ul>
            </div>

          </div>

          <hr className="border-secondary" />

          <div className="text-center small pb-2">
            © {year} Todos los derechos reservados. Versión {VERSION}
          </div>
        </div>
      </footer>

    </div>
  );
}

export default Inicio;